export const LetterProgressStage = {
    Created: "Créé",
    Abandonned: "Non selectionné",
    Validated: "Validé",
    Printed: "Imprimé",
    SentToPost: "Remis à la Poste",
    InDelivery: "En livraison",
    Delivered: "Livré",
    InvalidAddress: "Adresse invalide",
    RefusedByRecipient: "Refusé par le destinataire",
    OtherIssue: "Problème non identifié",
};